module.exports = "<textarea class=\"weui_textarea\" v-model=\"value\"></textarea>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-textarea.vue
 ** module id = 90
 ** module chunks = 0
 **/